import type { AnchoredExchange } from '../exchanges.js'
import { collapseActiveInlineTurn, expandActiveInlineTurn, getActiveInlineTurn } from '../inline/inline-agent-turn.js'
import { resolveBlockAnchorEl } from '../inline/resolve-block-anchor.js'
import { collapseExchangeCard, openExchangeCard } from './open-exchange.js'

/**
 * Open an exchange's card from its marker or the chat's Show in song (§3 "Reopen", §6). A collapsed live turn of that exchange expands on its
 * stream, at its element (the marker hides while the live card shows). Any other card gives way: one card at a time.
 */
export const reopenExchange = (
  exchange: AnchoredExchange,
  hostId: string,
  anchorEl: HTMLElement | null,
  /** The marker it's reopened from: focus returns there, and its own click toggles the card (Joni, #3067) */
  opener: HTMLElement | null = null
) => {
  const turn = getActiveInlineTurn()
  if (turn?.exchangeId && turn.exchangeId === exchange.id) {
    collapseExchangeCard()
    expandActiveInlineTurn(resolveBlockAnchorEl(exchange.anchor?.elementId) ?? turn.anchorEl ?? anchorEl)
    return
  }
  collapseActiveInlineTurn()
  openExchangeCard({ agentId: exchange.agentId, exchangeId: exchange.id, hostId, anchorEl, opener })
}
